const ALLERGEN = {
	gluten: 'GLUTEN',
	soy: 'SOY',
	eggs: 'EGGS',
	fish: 'FISH',
	milk: 'MILK',
	nuts: 'NUTS',
	celery: 'CELERY',
	mustard: 'MUSTARD',
	sesame: 'SESAME',
	sulfite: 'SULFITE'
};

export default ALLERGEN;